<template>
  <div class="quiz-stats">
    <div class="point-info-wrapper">
      <div class="point-info">
        <span class="text">ქულა:</span> <span class="correct">{{ correctAnswers }}</span> /
        {{ totalQuestions }}
      </div>
      <div class="point-info">
        <span class="text">შეცდომა:</span>
        <span class="wrong-answers">{{ wrongAnswers }}</span>
      </div>
    </div>
    <div class="timer-wrapper">
      <quiz-timer :isFinished="isFinished" :storage_key="storage_key" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['totalQuestions', 'correctAnswers', 'wrongAnswers', 'storage_key', 'isFinished'],
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .timer-wrapper {
    display: none;
  }
}
</style>
